export default __webpack_public_path__ + "static/media/Add.1c76cd1f.svg";